import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** Tela de contrato (modelo ou minuta) que pode ter texto não salvo. */
export interface PartnerContractUnsavedChanges {
  confirmLeave(): boolean | Observable<boolean>;
}

/**
 * Pergunta antes de sair do editor do modelo ou da minuta com texto não salvo (card 3462), na
 * navegação interna. Fechar ou recarregar a aba é tratado pelo `beforeunload` do componente. Mesmo
 * desenho do `aiModelsUnsavedChangesGuard`.
 */
export const partnerContractUnsavedChangesGuard: CanDeactivateFn<
  PartnerContractUnsavedChanges
> = component => (component?.confirmLeave ? component.confirmLeave() : true);
